<template>
  <div class="row">
    <div class="col-12">
      <h1>{{ $t('views.roomChooser.title') }}</h1>
    </div>
    <div v-if="isResetted()" class="col-12 teres-alert bg-lightblue my-3" role="alert">
      <feedback-message :message="$t('views.roomChooser.resetted')" />
    </div>
    <loading-container :state="state">
      <link-shopping-cart />
      <ul class="row list-unstyled mx-auto mt-2 p-1 p-inline-start-0">
        <li v-for="(room, index) in rooms" :key="index" class="col-12 mb-3">
            <router-link :to="'/room/' + room.id" class="d-flex row saal-overview no-underline">
              <div class="col-12 col-sm-4 col-md-2 px-0 bg-darker rooms-image">
                <room-image :room="room" />
              </div>
              <div class="col-12 col-sm-8 col-md-10 d-flex align-items-center">
                <div class="saal-desc p-2">
                  <h2 class="room-h2">{{ room.name }}</h2>
                  <p>{{ room.description }}</p>
                </div>
                <div class="ml-auto">
                  <span class="icon icon-navigation_pfeil_rechts" aria-hidden="true"></span>
                </div>
              </div>
            </router-link>
        </li>
      </ul>
    </loading-container>

    <div class="col-12 d-flex justify-content-end mt-3 px-0">
      <link-faq />
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Room } from '@/generated/openapi'
import { LoadingState } from '@/utils/loadingUtils'
import LoadingMixin from '@/mixins/LoadingMixin'

import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import LinkShoppingCart from '@/components/interaction/LinkShoppingCart.vue'
import RoomImage from '@/components/info/RoomImage.vue'
import { userService } from '@/services/userService'
import FeedbackMessage from '@/components/feedback/FeedbackMessage.vue'
import LinkFaq from '@/components/interaction/LinkFaq.vue'



export default defineComponent({
  name: 'RoomChooser',
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      rooms: [] as Room[]
    }
  },
  components: {
    LoadingContainer,
    LinkShoppingCart,
    RoomImage,
    FeedbackMessage,
    LinkFaq
  },
  created() {
    Promise.all([
      userService.getAllRooms(),
      userService.refreshShoppingCart(),
    ]).then(([rooms]) => {
      this.rooms = rooms
      this.state = LoadingState.success
    }).catch(this.handleError)
  },
  methods: {
    isResetted(): boolean {
      return this.$route.query.reset === 'y'
    }
  }
});
</script>
